module.exports = __webpack_public_path__ + "img/护理-5.b8e01627.png";